import { gwGet } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { setGetParams } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import makeOrCacheApiReq from '../../utils/apiCache';

const {
  SET_USER_GAS_RATE,
  FETCH_USER_GAS_RATE,
  FETCH_USER_GAS_RATE_ERROR,
  SET_REF_SWITCH_INFO,
  SET_REGISTER_OPEN_STATUS,
} = actionTypes;

const setUserGasRate = createBaseActions(SET_USER_GAS_RATE, 'data');

export const setRefSwitchInfo = createBaseActions(SET_REF_SWITCH_INFO, 'data');
export const setRegisterOpenStatus = createBaseActions(SET_REGISTER_OPEN_STATUS, 'data');

export const fetchHoldBnb = () => gwGet(API_PATH.ACQUIRE_HOLD_BNB_API);

export const fetchForbidenEmail = () => gwGet(API_PATH.GET_FORBIDEN_EMAIL_API_PATH);

export const fetchUrlAndProject = () => gwGet(API_PATH.URL_AND_PROJECT_API, null, null, false);

export const getUserGasRateRequest = (locale, name = 'gas_rate', req) => gwGet(`${API_PATH.USER_GAS_RATE_API_PATH}?${setGetParams({ name })}`, { locale }, req);

export const handleGasRateData = (data = {}) => data.data || data.config || 0;

export const fetchGasRate = async req => {
  let result = {};
  try {
    result = await makeOrCacheApiReq(
      API_PATH.USER_GAS_RATE_API_PATH,
      () => getUserGasRateRequest(null, 'gas_rate', req),
      res => res.success
    );
  } catch (error) {
    // nothing
  }
  return result;
};

export const fetchUserGasRate = name => async (dispatch, getState) => {
  dispatch({ type: FETCH_USER_GAS_RATE });
  try {
    const { locale } = getState();
    let data = await getUserGasRateRequest(locale, name);
    data = handleGasRateData(data);
    dispatch(setUserGasRate(data));
  } catch (error) {
    dispatch({ type: FETCH_USER_GAS_RATE_ERROR, error });
  }
};

export default {};
